import React from "react";
import "../Css/Home.css";

const Terms = () => {
  return (
    <div className="terms-main">
      <div className="terms">
        <b>U.S. Polo Assn.</b> is the official brand of the{" "}
        <b>United States Polo Association (USPA)</b>, the non-profit governing
        body for the sport of polo in the United States and one of the oldest
        sports governing bodies, having been founded in 1890. With a
        multi-billion-dollar global footprint and worldwide distribution through
        some 1,100 U.S. Polo Assn. retail stores and thousands of department
        stores as well as sporting goods channels, independent retailers and
        e-commerce, U.S. Polo Assn. offers apparel for men, women, and children,
        as well as accessories and footwear in more than 190 countries
        worldwide.
      </div>
    </div>
  );
};

export default Terms;
